import { lazy } from "react";
import { Navigate, Route, Routes } from "react-router";
import GeneralRoute from "./GeneralRoute";

const HomeOne = lazy(() => import("../pages/HomeOne"));
const About = lazy(() => import("../pages/About"));
const BlogGrid = lazy(() => import("../pages/BlogGrid"));
const BlogDetails = lazy(() => import("../pages/BlogDetails"));
const Contact = lazy(() => import("../pages/Contact"));
const SubjectAndGoals = lazy(() => import("../pages/SubjectAndGoals"));
const Structure = lazy(() => import("../pages/Structure"));
const Fond = lazy(() => import("../pages/Fond"));
const AdvisoryBoard = lazy(() => import("../pages/Advisory"));
const InspectionComission = lazy(() => import("../pages/InspectionComission"));
const InternalAudit = lazy(() => import("../pages/InternalAudit"));
const CorporateConsultant = lazy(() => import("../pages/CorporateConsultant"));
const Executives = lazy(() => import("../pages/Executives"));
const Certificates = lazy(() => import("../pages/Certificates"));
const Management = lazy(() => import("../pages/Management"));
const BusinessPlan = lazy(() => import("../pages/BusinessPlan"));
const Vacancies = lazy(() => import("../pages/Vacancies"));
const History = lazy(() => import("../pages/History"));
const History2 = lazy(() => import("../pages/History2"));
const History3 = lazy(() => import("../pages/History3"));
const TradeUnion = lazy(() => import("../pages/TradeUnion"));
const Votes = lazy(() => import("../pages/Votes"));
const Facts = lazy(() => import("../pages/Facts"));
const Emission = lazy(() => import("../pages/Emission"));
const Reports = lazy(() => import("../pages/Reports"));
const Audits = lazy(() => import("../pages/Audits"));
const MainIndicators = lazy(() => import("../pages/MainIndicators"));
const Others = lazy(() => import("../pages/Others"));
const StroyVagon = lazy(() => import("../pages/StroyVagon"));
const Telejka = lazy(() => import("../pages/Telejka"));
const Complect = lazy(() => import("../pages/Complect"));
const ImportProduct = lazy(() => import("../pages/ImportProduct"));
const InternalRegulations = lazy(() => import("../pages/InternalRegulations"));
const Virtour = lazy(() => import("../pages/Virtour"));
const Tenders = lazy(() => import("../pages/Tenders"));
const PurchaseList = lazy(() => import("../pages/PurchaseList"));
const Announcements = lazy(() => import("../pages/Announcements"));
const AnnouncementDetail = lazy(() => import("../pages/AnnouncementDetail"));

export default function AllRoutes() {
  return (
    <Routes>
      <Route exact path="/" element={<Navigate to="/uz" replace />} />
      <Route
        path={"/:siteLang"}
        element={
          <GeneralRoute>
            <HomeOne />
          </GeneralRoute>
        }
      />
      <Route
        path={"/:siteLang/about"}
        element={
          <GeneralRoute>
            <About />
          </GeneralRoute>
        }
      />
      <Route
        path={"/:siteLang/news"}
        element={
          <GeneralRoute>
            <BlogGrid />
          </GeneralRoute>
        }
      />
      <Route
        path={"/:siteLang/news/:id"}
        element={
          <GeneralRoute>
            <BlogDetails />
          </GeneralRoute>
        }
      />
      <Route
        path={"/:siteLang/contact"}
        element={
          <GeneralRoute>
            <Contact />
          </GeneralRoute>
        }
      />
      <Route
        path={"/:siteLang/subjectandgoals"}
        element={
          <GeneralRoute>
            <SubjectAndGoals />
          </GeneralRoute>
        }
      />
      <Route
        path={"/:siteLang/structure"}
        element={
          <GeneralRoute>
            <Structure />
          </GeneralRoute>
        }
      />
      <Route
        path={"/:siteLang/fond"}
        element={
          <GeneralRoute>
            <Fond />
          </GeneralRoute>
        }
      />
      <Route
        path={"/:siteLang/advisory-board"}
        element={
          <GeneralRoute>
            <AdvisoryBoard />
          </GeneralRoute>
        }
      />

      <Route
        path={"/:siteLang/inspection-comission"}
        element={
          <GeneralRoute>
            <InspectionComission />
          </GeneralRoute>
        }
      />

      <Route
        path={"/:siteLang/internal-audit"}
        element={
          <GeneralRoute>
            <InternalAudit />
          </GeneralRoute>
        }
      />

      <Route
        path={"/:siteLang/corporate-consultant"}
        element={
          <GeneralRoute>
            <CorporateConsultant />
          </GeneralRoute>
        }
      />

      <Route
        path={"/:siteLang/executives"}
        element={
          <GeneralRoute>
            <Executives />
          </GeneralRoute>
        }
      />

      <Route
        path={"/:siteLang/certificates"}
        element={
          <GeneralRoute>
            <Certificates />
          </GeneralRoute>
        }
      />

      <Route
        path={"/:siteLang/management"}
        element={
          <GeneralRoute>
            <Management />
          </GeneralRoute>
        }
      />

      <Route
        path={"/:siteLang/business-plan"}
        element={
          <GeneralRoute>
            <BusinessPlan />
          </GeneralRoute>
        }
      />

      <Route
        path={"/:siteLang/purchase-list"}
        element={
          <GeneralRoute>
            <PurchaseList />
          </GeneralRoute>
        }
      />

      <Route
        path={"/:siteLang/vacancies"}
        element={
          <GeneralRoute>
            <Vacancies />
          </GeneralRoute>
        }
      />

      <Route
        path={"/:siteLang/history"}
        element={
          <GeneralRoute>
            <History />
          </GeneralRoute>
        }
      />

      <Route
        path={"/:siteLang/history2"}
        element={
          <GeneralRoute>
            <History2 />
          </GeneralRoute>
        }
      />

      <Route
        path={"/:siteLang/history3"}
        element={
          <GeneralRoute>
            <History3 />
          </GeneralRoute>
        }
      />

      <Route
        path={"/:siteLang/trade-union"}
        element={
          <GeneralRoute>
            <TradeUnion />
          </GeneralRoute>
        }
      />

      <Route
        path={"/:siteLang/vote-results"}
        element={
          <GeneralRoute>
            <Votes />
          </GeneralRoute>
        }
      />

      <Route
        path={"/:siteLang/facts"}
        element={
          <GeneralRoute>
            <Facts />
          </GeneralRoute>
        }
      />

      <Route
        path={"/:siteLang/emission"}
        element={
          <GeneralRoute>
            <Emission />
          </GeneralRoute>
        }
      />

      <Route
        path={"/:siteLang/reports"}
        element={
          <GeneralRoute>
            <Reports />
          </GeneralRoute>
        }
      />

      <Route
        path={"/:siteLang/audits"}
        element={
          <GeneralRoute>
            <Audits />
          </GeneralRoute>
        }
      />

      <Route
        path={"/:siteLang/main-indicators"}
        element={
          <GeneralRoute>
            <MainIndicators />
          </GeneralRoute>
        }
      />

      <Route
        path={"/:siteLang/others"}
        element={
          <GeneralRoute>
            <Others />
          </GeneralRoute>
        }
      />

      <Route
        path={"/:siteLang/stroyvagon"}
        element={
          <GeneralRoute>
            <StroyVagon />
          </GeneralRoute>
        }
      />

      <Route
        element={
          <GeneralRoute>
            <Telejka />
          </GeneralRoute>
        }
        path={"/:siteLang/telejka"}
      />

      <Route
        element={
          <GeneralRoute>
            <InternalRegulations />
          </GeneralRoute>
        }
        path={"/:siteLang/internal-regulations"}
      />

      <Route
        element={
          <GeneralRoute>
            <Complect />
          </GeneralRoute>
        }
        path={"/:siteLang/komplekt"}
      />

      <Route
        element={
          <GeneralRoute>
            <ImportProduct />
          </GeneralRoute>
        }
        path={process.env.PUBLIC_URL + "/:siteLang/importproduct"}
      />

      <Route
        element={
          <GeneralRoute>
            <Virtour />
          </GeneralRoute>
        }
        path={process.env.PUBLIC_URL + "/:siteLang/virtour"}
      />

      <Route
        element={
          <GeneralRoute>
            <Tenders />
          </GeneralRoute>
        }
        path={process.env.PUBLIC_URL + "/:siteLang/tender"}
      />

      <Route
        element={
          <GeneralRoute>
            <Announcements />
          </GeneralRoute>
        }
        path={process.env.PUBLIC_URL + "/:siteLang/announcements"}
      />

      <Route
        element={
          <GeneralRoute>
            <AnnouncementDetail />
          </GeneralRoute>
        }
        path={process.env.PUBLIC_URL + "/:siteLang/announcements/:id"}
      />

      <Route element={<Navigate to="/uz" />} path="/:siteLang/*" />
    </Routes>
  );
}
